import { authClient } from '@/lib/auth-client.ts';
import type { ReactNode } from 'react';

export default function AuthRequired({ children }: { children: ReactNode }) {
  const session = authClient.useSession();

  if (session.isPending) return null;
  if (!session.data) return null;

  return children;
}
